module.exports = __webpack_public_path__ + "img/sponsor-05.2562f565.png";